import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  amSharedModelService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import controller from './preparation-item-document.controller';
import directive from './preparation-item-document.directive';


export default angular.module('app.components.advisory.auditTrail.preparationItemDocument', [
  alerts,
  amDataService,
  amSharedModelService,
  confirmDialog,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('amPreparationItemDocument', directive)
  .controller('PreparationItemDocumentController', controller)
  .name;

console.log('app.components.advisory.auditTrail.preparationItemDocument created');
